import {ChangeDetectionStrategy, Component, forwardRef,Input} from '@angular/core';
// ...existing code...
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { provideNativeDateAdapter } from '@angular/material/core';
// ...existing code...
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DDD',
  },
  display: {
    dateInput: 'DDD',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'DDD',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
@Component({
  selector: 'app-datepicker',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule],
  templateUrl: './datepicker.html',
  styleUrl: './datepicker.scss',
  providers: [
    provideNativeDateAdapter(),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> Datepicker),
      multi:true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class Datepicker implements ControlValueAccessor {
  @Input() formControl!: FormControl;
  @Input() label : string = '';
  onChangeCb?: (value:any) => void;
  value: any = null;
  @Input() errorMessage : string = ''
  writeValue(event: Event): void {
    this.value = event;
  }
  registerOnChange(value:any): void {
    this.onChangeCb = value;
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }
  setValue(event:Event){
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChangeCb?.(value);

  }

}
